
/** A Redux selector to retrieve webcast data
 * @param state - The Redux state
 * @param {string} [collectionId] - The collectionId (channelId+webcastId) to fetch
 * @return - A webcast data object or an empty object
 */

function selectWebcast (state: any, collectionId = '') {

  if (!collectionId) collectionId = `${state.config.channelId}${state.config.webcastId}`

  const webcast = state.webcast.collection[collectionId]

  if (webcast && webcast.status.hasData) {

    return webcast.data

  }

  return {}

}

export default selectWebcast
